import BaseRepository from '@/baseRepository/BaseRepository';
const resource = `/api/v1/suppliers`;
const buyerResource = `/api/v1/buyers`;

export default {
  getSuppliersList(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}`, {
      baseURL,
      headers,
      params,
    });
  },
  getSupplierByUser(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/by-user`, {
      baseURL,
      headers,
      params,
    });
  },
  getSupplierByUserSupplierPanel(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`/api/v1/merchants/byuser`, {
      baseURL,
      headers,
      params,
    });
  },
  createSupplier(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}`, body, {
      baseURL,
      headers,
      params,
    });
  },
  createSupplierAsConsumer(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${buyerResource}`, body, {
      baseURL,
      headers,
      params,
    });
  },
  createBuyer(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${buyerResource}`, body, {
      baseURL,
      headers,
      params,
    });
  },
  editSupplier(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.put(`${resource}`, body, {
      baseURL,
      headers,
      params,
    });
  },
  editSupplierAsConsumer(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.put(`${buyerResource}`, body, {
      baseURL,
      headers,
      params,
    });
  },
  changeToBusiness(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${buyerResource}/request-transfer-to-supplier`, body, {
      baseURL,
      headers,
      params,
    });
  },
    editSupplierByVisitor(merchantId, body, baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.put(`${resource}/${merchantId}/byadmin`, body, {
      baseURL,
      headers,
      params,
    });
  },
};
